(() => {
  const root = document.querySelector('.vd-sticker-wall');
  if (!root) return;
  const canvas = root.querySelector('[data-wall-canvas]');
  const shuffleButton = root.querySelector('[data-wall-shuffle]');
  const moreButton = root.querySelector('[data-wall-more]');
  const status = root.querySelector('[data-wall-status]');
  const totalPages = Math.max(1, Math.ceil(Number(root.dataset.total || 1499) / 150));
  let catalog = [], catalogPromise = null, trendDeck = [], libraryDeck = [], signDeck = [], flagDeck = [], products = [];
  let decksReady = false, loadedCount = 0, exhausted = false;
  let busy = false, generation = 0, controller = new AbortController();
  const paddingCache = new Map();
  function clipBlankPadding(img, link) {
    if (link.dataset.trend === 'true') return;
    if (!paddingCache.has(img.src)) paddingCache.set(img.src, new Promise(resolve => {
      const source = new Image();
      source.crossOrigin = 'anonymous';
      source.onerror = () => resolve(null);
      source.onload = () => {
        try {
          const sample = document.createElement('canvas');
          sample.width = sample.height = 128;
          const context = sample.getContext('2d', {willReadFrequently:true});
          context.drawImage(source,0,0,128,128);
          const pixels = context.getImageData(0,0,128,128).data;
          let left=128, top=128, right=-1, bottom=-1;
          for(let y=0;y<128;y++) for(let x=0;x<128;x++) {
            const i=(y*128+x)*4;
            if(pixels[i+3]<20 || Math.min(pixels[i],pixels[i+1],pixels[i+2])>242) continue;
            left=Math.min(left,x);right=Math.max(right,x);top=Math.min(top,y);bottom=Math.max(bottom,y);
          }
          if(right<left) return resolve(null);
          resolve(`${Math.max(0,top-4)/1.28}% ${Math.max(0,127-right-4)/1.28}% ${Math.max(0,127-bottom-4)/1.28}% ${Math.max(0,left-4)/1.28}%`);
        } catch (_) {resolve(null);}
      };
      source.src=img.src;
    }));
    paddingCache.get(img.src).then(inset => {if(inset && link.isConnected) link.style.clipPath=`inset(${inset})`;});
  }
  const shuffle = items => {
    const result = [...items];
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  };
  async function fetchPool(path, page) {
    const url = new URL(path, location.origin);
    url.searchParams.set('section_id', 'vd-sticker-wall-pool');
    url.searchParams.set('page', page);
    const response = await fetch(url, {signal: controller.signal, credentials:'same-origin'});
    if (!response.ok) throw new Error('Unable to load stickers');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const data = doc.querySelector('[data-vd-wall-pool]');
    if (!data) throw new Error('Sticker pool missing');
    return JSON.parse(data.textContent);
  }
  async function loadCatalog() {
    if (catalog.length) return;
    if (!catalogPromise) catalogPromise = (async () => {
      const first = await fetchPool('/collections/awesome-stickers',1);
      const byId = new Map(first.products.map(product => [product.id,product]));
      let nextPage = 2;
      const pages = first.pages || totalPages;
      await Promise.all(Array.from({length:Math.min(3,pages-1)},async () => {
        while(nextPage<=pages) {
          const data=await fetchPool('/collections/awesome-stickers',nextPage++);
          data.products.forEach(product=>byId.set(product.id,product));
        }
      }));
      const allProducts=[...byId.values()];
      const unrestricted=allProducts.filter(product=>!product.sign && !product.flag);
      // Each restricted category stays below 1%, with fresh samples on reshuffle.
      catalog=allProducts;
      root.dataset.signLimit=String(Math.floor(unrestricted.length/99));
      root.dataset.flagLimit=root.dataset.signLimit;
      root.dataset.catalogSize=String(catalog.length);
    })().catch(error=>{catalogPromise=null;throw error;});
    await catalogPromise;
  }
  function layout() {
    if (!products.length) return;
    const width = canvas.clientWidth;
    const columns = width < 750 ? 5 : Math.max(3, Math.ceil(width / 175));
    const stepX = width / (columns - 1);
    const stepY = Math.min(135, stepX * .72);
    const size = stepX * 1.6;
    [...canvas.querySelectorAll(':scope > .vd-wall-sticker')].forEach((link, index) => {
      const row = Math.floor(index / columns), column = index % columns;
      link.style.setProperty('--wall-x', `${column * stepX + (row % 2 ? stepX * .15 : -stepX * .08)}px`);
      link.style.setProperty('--wall-y', `${row * stepY + size * .32 + Number(link.dataset.jitter) * stepY}px`);
      link.style.setProperty('--wall-size', `${size}px`);
    });
    [...canvas.querySelectorAll('.vd-wall-underlay > .vd-wall-sticker')].forEach((link,index) => {
      const row=Math.floor(index/columns), column=index%columns;
      link.style.setProperty('--wall-x',`${column*stepX + (row%2 ? -stepX*.32 : stepX*.42)}px`);
      link.style.setProperty('--wall-y',`${row*stepY + size*.32 + stepY*.46}px`);
      link.style.setProperty('--wall-size',`${size}px`);
    });
    canvas.style.height = `${Math.ceil(products.length / columns) * stepY + size * .35}px`;
  }
  function makeLink(product, index, delay) {
    const link = document.createElement('a');
    link.className = 'vd-wall-sticker';
    link.href = product.url;
    link.title = `${product.title} · ${product.price}`;
    link.setAttribute('aria-label', `Shop ${product.title}`);
    link.dataset.id = product.id;
    link.dataset.trend = String(product.trend);
    link.dataset.sign = String(Boolean(product.sign));
      link.dataset.flag = String(Boolean(product.flag));
    link.dataset.jitter = (Math.random() * .16 - .08).toFixed(3);
    link.style.setProperty('--wall-angle', `${Math.round(Math.random() * 44 - 22)}deg`);
    link.style.setProperty('--wall-delay', `${Math.min(delay, 500)}ms`);
    link.style.zIndex = String(index % 70 + 1);
    const img = document.createElement('img');
    img.crossOrigin = 'anonymous';
    img.src = product.image;
    img.alt = '';
    img.width = img.height = 480;
    img.loading = index < 18 ? 'eager' : 'lazy';
    img.decoding = 'async';
    img.style.visibility = 'hidden';
    img.addEventListener('load', async () => {
      await window.VDCollageArtwork.prepare(img);
      if (img.dataset.collageArtwork !== 'unavailable') img.style.visibility = '';
    }, {once:true});
    const label = document.createElement('span');
    label.textContent = `${product.title} · ${product.price}`;
    link.append(img, label);
    return link;
  }
  async function loadBatch(reset = false) {
    if (busy || (exhausted && !reset)) return;
    busy = true;
    const token = generation;
    shuffleButton.disabled = moreButton.disabled = true;
    status.textContent = reset ? 'Shuffling your sticker wall…' : 'Adding more stickers…';
    try {
      await loadCatalog();
      if(!decksReady || reset) {
        trendDeck=shuffle(catalog.filter(product=>product.trend && !product.sign && !product.flag));
        libraryDeck=shuffle(catalog.filter(product=>!product.trend && !product.sign && !product.flag));
        signDeck=shuffle(catalog.filter(product=>product.sign && !product.flag)).slice(0,Number(root.dataset.signLimit));
        flagDeck=shuffle(catalog.filter(product=>product.flag && !product.sign)).slice(0,Number(root.dataset.flagLimit));
        root.dataset.wallDesigns=String(trendDeck.length+libraryDeck.length+signDeck.length+flagDeck.length);
        loadedCount=0;decksReady=true;exhausted=false;
      }
      const next = [];
      for (let i = 0; i < 144 && (trendDeck.length || libraryDeck.length || signDeck.length || flagDeck.length); i++) {
        if ((loadedCount+next.length+1)%100===99 && flagDeck.length) {next.push(flagDeck.pop());continue;}
        if ((loadedCount+next.length+1)%100===0 && signDeck.length) {next.push(signDeck.pop());continue;}
        const preferred = i%3===2 ? libraryDeck : trendDeck;
        const alternate = i%3===2 ? trendDeck : libraryDeck;
        if (!preferred.length && !alternate.length) break;
        next.push((preferred.length ? preferred : alternate).pop());
      }
      if (token !== generation) return;
      const mixed = shuffle(next);
      const foreground=mixed.slice(0,Math.ceil(mixed.length/2));
      const background=mixed.slice(foreground.length);
      const offset = reset ? 0 : products.length;
      const fragment = document.createDocumentFragment();
      const backing = document.createDocumentFragment();
      foreground.forEach((product, i) => fragment.appendChild(makeLink(product, offset + i, i * 12)));
      background.forEach((product,i) => backing.appendChild(makeLink(product,offset+i,i*8)));
      let underlay=canvas.querySelector('.vd-wall-underlay');
      if(reset || !underlay) {underlay=document.createElement('div');underlay.className='vd-wall-underlay';}
      if (reset) {canvas.replaceChildren(underlay,fragment);products = foreground;}
      else {canvas.querySelector('.vd-wall-fallback')?.remove();if(!underlay.isConnected)canvas.prepend(underlay);canvas.appendChild(fragment);products.push(...foreground);}
      underlay.appendChild(backing);
      layout();
      loadedCount+=mixed.length;
      exhausted=trendDeck.length+libraryDeck.length===0;
      root.dataset.loadedDesigns=String(loadedCount);
      root.dataset.exhausted=String(exhausted);
      status.textContent = exhausted ? `All ${root.dataset.wallDesigns} designs on this wall shown. Reshuffle for a fresh wall.` : `${loadedCount} of ${root.dataset.wallDesigns} unique designs. Keep scrolling.`;
      moreButton.textContent=exhausted ? 'Every design is on the wall' : 'Load more stickers';
    } catch (error) {
      if (error.name !== 'AbortError') status.textContent = 'Could not load more. Tap Load more to try again.';
    } finally {
      if (token === generation) {
        busy = false;
        shuffleButton.disabled = false;
        moreButton.disabled = exhausted;
      }
    }
  }
  shuffleButton.addEventListener('click', () => {
    generation++;
    controller.abort();
    controller = new AbortController();
    busy = false;
    trendDeck = []; libraryDeck = []; signDeck = []; flagDeck = []; decksReady=false; exhausted=false;
    canvas.scrollIntoView({block:'start', behavior:'instant'});
    loadBatch(true);
  });
  moreButton.addEventListener('click', () => loadBatch());
  new ResizeObserver(layout).observe(canvas);
  const observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) loadBatch();
  }, {rootMargin:'700px'});
  loadBatch().then(() => observer.observe(root.querySelector('[data-wall-sentinel]')));
})();

